import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignoutCallbackComponent } from './signout-callback.component';



@NgModule({
  declarations: [SignoutCallbackComponent],
  imports: [
    CommonModule
  ]
})
export class SignoutCallbackModule { }
